import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import Clientes from "../components/Clientes";
import Articles from "../components/Articles";
import { useLanguage } from "../context/LanguageContext";
import Contact from "../components/Contact";
import Magazine from "../components/Magazine";
import HeroEditorial from "../img/HEROEDITORIAL.jpg";
import magazineLogo from "../img/revista_logo.PNG";
import clienteEditorial1 from "../img/clientes/nuevoCliente1.png";
import clienteEditorial2 from "../img/clientes/nuevoCliente2.png";
import clienteEditorial3 from "../img/clientes/nuevoCliente3.png";
import clienteEditorial4 from "../img/clientes/nuevoCliente4.png";
import clienteEditorial5 from "../img/clientes/nuevoCliente5.png";
import clienteEditorial6 from "../img/clientes/nuevoCliente6.png";
import clienteEditorial7 from "../img/clientes/nuevoCliente7.png";
import clienteEditorial8 from "../img/clientes/nuevoCliente8.png";
import clienteEditorial9 from "../img/clientes/nuevoCliente9.png";
import clienteEditorial10 from "../img/clientes/nuevoCliente10.png";
import clienteEditorial11 from "../img/clientes/nuevoCliente11.png";
import clienteEditorial12 from "../img/clientes/nuevoCliente12.png";
import clienteEditorial13 from "../img/clientes/nuevoCliente13.png";
import clienteEditorial14 from "../img/clientes/nuevoCliente14.png";
import clienteEditorial15 from "../img/clientes/nuevoCliente15.png";
import clienteEditorial16 from "../img/clientes/nuevoCliente16.png";
import clienteEditorial17 from "../img/clientes/nuevoCliente17.png";

const Editorial = ({ contactRef }) => {
  const { language } = useLanguage();
  const magazineRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const shouldScrollToMagazine = sessionStorage.getItem("scrollToMagazine");
    const shouldScrollToContact = sessionStorage.getItem("scrollToContact");

    if (shouldScrollToMagazine === "true" && magazineRef.current) {
      sessionStorage.removeItem("scrollToMagazine");
      setTimeout(() => {
        magazineRef.current.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else if (shouldScrollToContact === "true" && contactRef.current) {
      sessionStorage.removeItem("scrollToContact");
      setTimeout(() => {
        contactRef.current.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location.pathname, contactRef]);

  return (
    <div>
      <Hero backgroundImage={HeroEditorial} additionalImage={magazineLogo} />
      <Articles />
      <div ref={magazineRef}>
        <Magazine />
      </div>
      <Clientes
        title={
          language === "ES" ? "Confían en nosotros" : "Confien en nosaltres"
        }
        clientesData={[
          {
            id: 1,
            src: clienteEditorial1,
            alt: "Cliente 1",
            link: "https://www.altahousehotel.com/",
          },
          {
            id: 2,
            src: clienteEditorial2,
            alt: "Cliente 2",
            link: "https://www.calonge.cat/",
          },
          {
            id: 3,
            src: clienteEditorial3,
            alt: "Cliente 3",
            link: "https://www.grupcostabravacentre.com/ca/",
          },
          {
            id: 4,
            src: clienteEditorial4,
            alt: "Cliente 4",
            link: "https://www.lavinyeta.es/ca/celler",
          },
          {
            id: 5,
            src: clienteEditorial5,
            alt: "Cliente 5",
            link: "https://www.cuinadelempordanet.com/es/inicio/",
          },
          {
            id: 6,
            src: clienteEditorial6,
            alt: "Cliente 6",
            link: "https://www.doemporda.cat/",
          },
          {
            id: 7,
            src: clienteEditorial7,
            alt: "Cliente 7",
            link: "https://capmany.cat/",
          },
          {
            id: 8,
            src: clienteEditorial8,
            alt: "Cliente 8",
            link: "https://upcyclingbottles.com/",
          },
          {
            id: 9,
            src: clienteEditorial9,
            alt: "Cliente 9",
            link: "https://www.grupoliveda.com/",
          },
          {
            id: 10,
            src: clienteEditorial10,
            alt: "Cliente 10",
            link: "https://www.terraremota.com/",
          },
          {
            id: 11,
            src: clienteEditorial11,
            alt: "Cliente 11",
            link: "https://www.cooperativagarriguella.com/ca/",
          },
          {
            id: 12,
            src: clienteEditorial12,
            alt: "Cliente 12",
            link: "https://olivardots.com/",
          },
          {
            id: 13,
            src: clienteEditorial13,
            alt: "Cliente 13",
            link: "https://masgelipals.cat/",
          },
          {
            id: 14,
            src: clienteEditorial14,
            alt: "Cliente 14",
            link: "https://closdagon.com/",
          },
          {
            id: 15,
            src: clienteEditorial15,
            alt: "Cliente 15",
            link: "https://www.perelada.com/",
          },
          {
            id: 16,
            src: clienteEditorial16,
            alt: "Cliente 16",
            link: "https://gcemporda.com/",
          },
          {
            id: 17,
            src: clienteEditorial17,
            alt: "Cliente 17",
            link: "https://terradeventshotel.com",
          },
        ]}
      />
      <Contact contactRef={contactRef} />
    </div>
  );
};

export default Editorial;
